import { Injectable, signal } from '@angular/core';
import { UserAccount } from './UserAccount.model';

@Injectable({
    providedIn: 'root',
})
export class UserAccountService {
    private readonly _displayName = signal('');
    public readonly displayName = this._displayName.asReadonly();
    private readonly _email = signal<string>('');
    public readonly email = this._email.asReadonly();
    private readonly _isSysAdmin = signal<boolean>(false);
    public readonly isSysAdmin = this._isSysAdmin.asReadonly();

    public setUserAccount(userAccount: UserAccount): void {
        this._displayName.set(userAccount?.displayName ?? '');
        this._email.set(userAccount?.email ?? '');
        this._isSysAdmin.set(userAccount?.isSysAdmin ?? false);
    }
}
